import React, { Key, ReactNode } from "react"

import { MenuProps } from "antd"
import { ColumnType, ColumnsType } from "antd/es/table"
import dayjs from "dayjs"

import { Permission } from "./IPermission"


export type MenuItem = Required<MenuProps>["items"][number];
export interface MenuOption {
  permission?: Permission;
  icon?: React.ReactNode;
}
export type MenuPermission = MenuItem & { permission?: Permission }

export interface IFilterProps {
  filters: IFilterField[];
  submitText?: string;
  cancelText?: string;
  onSubmit?: (filters: string) => void;
  onCancel?: () => void;
  filterKey: string
}

export interface ITableColumn<T> extends ColumnType<T> {
  isVisible: boolean;
  title: ReactNode;
  key: Key;
  sorterField?: string
  order: number
  children?: ColumnsType<T>;
  editable?: boolean;
}

export interface IFilterField {
  name: string;
  text: string;
  value?: string | boolean | dayjs.Dayjs | dayjs.Dayjs[] | number | number[] | null
  operator?: FilterFieldOperator;
  type: FilterFieldType;
  hidden?: boolean;
  /**
   * точность сравнения на равенство для NumberWithOperator
   */
  equalAccuracy?: 2 | 3 | 4;
}

export interface IFilterSelectField extends IFilterField {
  values: { id: number | string | boolean, name: string }[];
}

export type FilterField = IFilterField | IFilterSelectField;

export enum FilterFieldType {
  Text,
  Select,
  MultiSelect,
  Date,
  DateRange,
  Number,
  NumberWithOperator,
  Checkbox
}

export enum FilterFieldOperator {
  Equal,
  NotEqual,
  LessThan,
  GreaterThan,
  GreaterThanOrEqual,
  LessThanOrEqual,
  Contains,
  NotContains,
  EqualWithMathRound
}

export interface IErrorValidate {
  errorFields: { errors: string[]; name: string[] }[];
}

export interface ISelectListItem {
  value: number,
  label: string
}

export interface IDictionary<T> {
  [key: string]: T
}